// src/components/ClientLogos.jsx
import { useTranslation } from "react-i18next";
import { CLIENTS } from "../data/content";

export default function ClientLogos() {
  const { t } = useTranslation();

  return (
    <section className="py-10 border-y border-slate-200 bg-white">
      <div className="mx-auto max-w-7xl px-4">
        <p className="text-sm uppercase tracking-wider text-slate-500 mb-5">
          {t("logos_heading")}
        </p>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-8">
          {CLIENTS.map((c) => {
            const name = t(c.nameKey);          // e.g. clients.innerManifest.name
            const blurb = t(c.blurbKey);        // tooltip text
            const Tag = c.url ? "a" : "div";

            return (
              <Tag
                key={c.nameKey}
                href={c.url}
                target={c.url ? "_blank" : undefined}
                rel={c.url ? "noopener noreferrer" : undefined}
                className="h-20 sm:h-24 rounded-xl border border-slate-200 flex flex-col items-center justify-center bg-white p-3 text-center"
                aria-label={name}
                title={blurb}
              >
                <img
                  src={c.logo}
                  alt={name}
                  className="max-h-10 sm:max-h-12 max-w-[80%] object-contain opacity-70 grayscale hover:opacity-100 hover:grayscale-0 transition"
                  loading="lazy"
                />
                <span className="mt-2 text-[11px] text-slate-600">{name}</span>
              </Tag>
            );
          })}
        </div>
      </div>
    </section>
  );
}
